<template>
  <div>
    <div>
      <div style="background-color: white">
        <div style="width: 19rem" v-for="(icard, index) in icard_data" :key="index">
          <div>
            <div class="row ml-0" :class="topBar" style="height: 20px; justify-content: center"></div>
              <v-row v-if="tenant == 'vvp'" justify="center">
                <v-col cols="12" sm="2" md="2" class="pb-0" style="padding-top: 20px">
                  <img :src="common_data.logo" style="width: 70px; height: 70px" alt="logo" />
                </v-col>
                <v-col cols="12" sm="7" md="7" class="pb-0" style="padding-left: 29px; padding-top: 18px; ">
                  <div :class="colorClass" class="school-name"
                    style="font-size: 16px">
                    {{ common_data.school_name }}
                  </div>
                </v-col>
                <v-col cols="12" sm="2" md="2" class="pl-0" align="right" style="padding-top: 27px">
                  <!-- <qrcode-vue :value="icard.emp_code" :size="40"></qrcode-vue> -->
                </v-col>
              </v-row>
              <v-row v-else justify="center">
                <v-col cols="12" sm="2" md="2" class="pb-0" style="padding-left: 31px; padding-top: 20px">
                  <img :src="common_data.logo" style="width: 70px; height: 70px" alt="logo" />
                </v-col>
                <v-col cols="12" sm="6" md="6" class="pb-0">
                  <div v-if="tenant == 'wws'" :class="colorClass" class="school-name"
                    style="padding-left: 45px; font-size: 19px">
                    {{ common_data.school_name }}
                    <div style="font-size: 10px">
                      <span v-if="org_id == '1'">wakad</span>
                      <span v-else-if="org_id == '2'">hadapsar</span>
                    </div>
                  </div>
                  <div v-if="tenant == 'uwws'" :class="colorClass" class="school-name"
                    style="padding-left: 45px; font-size: 19px">
                    {{ common_data.school_name }}
                    <div style="font-size: 10px">
                      <span>balewadi</span>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="3" md="3" align="right" style="padding-top: 27px">
                  <!-- <qrcode-vue :value="icard.emp_code" :size="40"></qrcode-vue> -->
                </v-col>
              </v-row>

            <div v-if="icard.icard_temp.emp_photo.field_value" class="row" style="
                justify-content: center;
                margin-left: 2px;
                margin-top: 10px;
              ">
              <img v-if="icard.icard_temp.emp_photo.field_value" :src="awspath + icard.icard_temp.emp_photo.field_value" width="140px" height="170px"
                alt="Employee photo" />
            </div>
            <br />
            <div :class="borderClass" class="borderDiv">
              <p style="
                  transform: rotate(270deg);
                  margin-top: 40px;
                  font-family: Arial;
                ">
                FACULTY
              </p>
            </div>
            <div class="row">
              <div v-if="tenant == 'wws'" class="py-2 box1" style="background-color: rgb(98, 62, 126); font-size: 20px">
                wws
                <span v-if="org_id == '1'" style="font-size: 10px">wakad</span>
                <span v-else-if="org_id == '2'" style="font-size: 9px">hadapsar</span>
              </div>
              <div v-if="tenant == 'uwws'" class="py-2 box1"
                style="background-color: rgb(18, 93, 142); font-size: 20px">
                uws
                <span style="font-size: 9px">balewadi</span>
              </div>
              <div v-if="tenant == 'vvp'" class="py-2 box1" style="background-color: rgb(0, 83, 135); font-size: 25px">
                vv
                <span style="font-size: 13px">pune</span>
              </div>
              <div class="name">
                {{ icard.icard_temp.emp_fullname.field_value }} <br />
                <span style="
                    font-weight: 400;
                    text-align: left;
                    font-style: italic;
                    font-size: 13px;
                  ">{{ icard.icard_temp.emp_designation.field_value }}</span>
              </div>
            </div>
            <div class="row">
              <div class="sign">
                <img v-if="icard.icard_temp.is_principal || icard.icard_temp.employee_code == 'DIRVVP'" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Trupti_Bharat_Agarwal.png" width="32" height="25" style="margin-top: 5px; margin-bottom: -5px;"
                  alt="sign" />
                <img v-else :src="common_data.sign" width="32" height="25" style="margin-top: 5px; margin-bottom: -5px;"
                  alt="sign" />
                  <div v-if="tenant !== 'vvp'">
                    <span>{{icard.icard_temp.is_principal ? 'Director':'Principal'}}</span>
                  </div>
                  <div v-if="tenant === 'vvp'">
                    <div style="margin-left: -14px;">{{icard.icard_temp.is_principal || icard.icard_temp.employee_code == 'DIRVVP' ? 'Chairperson':'Principal'}}</div>
                  </div>
              </div>
              <div class="code">Employee No. : {{ icard.icard_temp.employee_code }} <br /></div>
            </div>
            <br />
            <div :class="bottomBar" class="row mt-2 pl-2 py-3" style="
                height: 70px;
                color: white;
                justify-content: center;
                font-family: Arial Narrow;
              ">
              <center>
                <div style="font-size: 15px">{{ common_data.school_address }}</div>
                <div style="font-weight: bold; font-size: 14px">
                  {{ common_data.school_contact }} | {{ common_data.website }}
                </div>
              </center>
            </div>
          </div>
          <div class="pagebreak" style="height: 495px">
            <div class="row pt-7 pl-12" style="
                background-color: rgb(210, 35, 42);
                height: 110px;
                font-weight: bold;
                color: white;
                font-size: 12px;
                font-family: Arial Narrow;
              ">
              Instruction : <br />
              <ol style="margin-top: -10px">
                <li v-for="(i, index) in common_data.instruction" :key="index">
                  {{ i.topic }}
                </li>
              </ol>
            </div>

            <div class="row ml-7 mr-7" style="
                font-family: Arial Narrow;
                font-weight: bold;
                font-size: 12px;
              ">
              <span>Address : </span>
              <v-col cols="12" sm="10" class="pa-0" style="height: 66px">{{
                icard.icard_temp.emp_address.field_value
              }}</v-col><br />
              <v-col cols="12" sm="10" class="pa-0">Blood Group : {{ icard.icard_temp.emp_blood_group.field_value }}</v-col><br />
              <v-col cols="12" sm="10" class="pa-0">Date of Birth : {{ icard.icard_temp.emp_date_of_birth.field_value }}</v-col><br />
              <v-col cols="12" sm="10" class="pa-0">Contact No. : {{ icard.icard_temp.emp_mobile_no.field_value }}</v-col><br /><br />
              <v-col cols="12" sm="10" class="pa-0">Emergency Contact Person / No. : <br />
                {{ icard.icard_temp.emp_emergency_contact_person.field_value }} /
                {{ icard.icard_temp.emp_emergency_contact_no.field_value }}</v-col><br />
              <div></div>
            </div>
            <br />
            <center>
              <img :src="awspath + icard.icard_temp.emp_signature.field_value" width="50" height="35" alt="sign" />
              <div style="
                  font-family: Arial Narrow;
                  font-weight: bold;
                  font-size: 12px;
                  margin-top: -5px;
                ">
                Signature of Card Holder
              </div>
            </center>
            <div>
              <img style="
                  height: 103px;
                  width: 283px;
                  margin-left: 15px;
                  position: absolute;
                " :src="common_data.watermark_back" />
            </div>
            <div :class="bottomBar" class="row ml-0" style="height: 18px; justify-content: center; margin-top: 95px">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },
  data: () => ({
    stud_data: null,
    comp_load: false,
    icard_data: [],
    tenant: null,
    org_id: null,
  }),
  mounted() {
    this.inst_data = localStorage.getItem("inst_data");
    this.icard_data = JSON.parse(localStorage.getItem("icard_data"));
    this.common_data = JSON.parse(localStorage.getItem("common_data"));
    this.awspath = localStorage.getItem("awspath");
    this.tenant = localStorage.getItem("EPS-tenant");
    this.org_id = localStorage.getItem("EPS-org-id");
  },
  computed: {
    topBar() {
      switch (this.tenant) {
        case "vvp":
          return "vvp-top";

        case "wws":
          return "wws-top";

        case "uwws":
          return "wws-top";
      }
    },
    colorClass() {
      switch (this.tenant) {
        case "vvp":
          return "vvp-color";

        case "wws":
          return "wws-color";

        case "uwws":
          return "uwws-color";
      }
    },
    borderClass() {
      switch (this.tenant) {
        case "vvp":
          return "vvp-border";

        case "wws":
          return "wws-border";

        case "uwws":
          return "uwws-border";
      }
    },
    bottomBar() {
      switch (this.tenant) {
        case "vvp":
          return "vvp-bottom";

        case "wws":
          return "wws-bottom";

        case "uwws":
          return "uwws-bottom";
      }
    },
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
.wws-top {
  background-color: rgb(245, 232, 202);
}

.vvp-top {
  background-color: rgb(210, 35, 42);
}

.vvp-color {
  color: rgb(0, 83, 135);
  font-size: 13.8px !important;
}

.wws-color {
  color: rgb(98, 62, 126);
}

.uwws-color {
  color: rgb(18, 93, 142);
}

.vvp-border {
  border: 1px solid rgb(0, 83, 135);
}

.wws-border {
  border: 1px solid rgb(98, 62, 126);
}

.uwws-border {
  border: 1px solid rgb(18, 93, 142);
}

.vvp-bottom {
  background-color: rgb(0, 83, 135);
}

.wws-bottom {
  background-color: rgb(98, 62, 126);
}

.uwws-bottom {
  background-color: rgb(18, 93, 142);
}

.school-name {
  text-transform: uppercase;
  font-weight: 800;
  font-family: "Montserrat", sans-serif;
  line-height: 100%;
  margin-top: 6px;
}

.borderDiv {
  height: 90px;
  width: 55px;
  margin-top: -114px;
  margin-left: 34px;
}

.box1 {
  height: 55px;
  width: 55px;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  margin-left: 46px;
  line-height: 90%;
  font-family: "Montserrat", sans-serif;
  text-align: center;
}

.name {
  width: 195px;
  font-weight: bold;
  font-family: "Montserrat", sans-serif;
  margin-left: 10px;
  margin-top: 10px;
  line-height: 100%;
  border-bottom: 1px solid red;
}

.sign {
  height: 37px;
  width: 40px;
  margin-left: 50px;
  font-family: Arial Narrow;
}

.code {
  width: 170px;
  font-weight: bold;
  font-family: Arial Narrow;
  text-align: center;
  margin-top: 5px;
}

@media print {
  .pagebreak {
    page-break-before: always !important;
    /* height: 200px; */
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  @page {
    /* margin: 0mm; */
    margin: -1.2645833mm;
    /* size: 85mm 55mm; */
    size: 53mm 85mm;
  }
}
</style>